export function numberWithCommas(x) {
  x = x.toString()
  var pattern = /(-?\d+)(\d{3})/
  while (pattern.test(x)) x = x.replace(pattern, '$1,$2')
  return x
}

export function valueLabelFormat(value) {
  const units = ['K', 'M']

  let unitIndex = 0
  let scaledValue = value

  if (scaledValue < 1000000) {
    return `$${scaledValue / 1000}K`
  }
  while (scaledValue >= 1000000 && unitIndex < units.length - 1) {
    unitIndex += 1
    scaledValue /= 1000000
  }
  return `$${scaledValue}${units[unitIndex]}`
}
